const currentYear = new Date().getFullYear();

const locale = {
    code: "tr",
    label: "Türkçe",
    NAV_BAR: {
        home: "Ana Sayfa",
        homeId: "home",
        aboutus: "Hakkımızda",
        aboutId: "aboutus",
        faq: "SSS",
        faqId: "faq-section",
        contact: "İletişim",
        contactId: "contact-section",
        button: "Erken Erişim Al",
    },

    HERO: {
        heroHeading: "Menünüz, anında erişilebilir",
        heroParagraph:
            "Menünüzü tek bir QR koduyla oluşturun, güncelleyin ve paylaşın — hiçbir zahmet yok, yeniden baskıya gerek yok.",
        button: "Erken Erişim Al",
        downloadText: "Şurada indir",
        appStore: "App Store",
        getItOn: "GET IT ON",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "Hizmetlerimiz",
        cards: [
            {
                title: "Menü oluştur ve yükle",
                description:
                    "Sadece birkaç tıklamayla menünüzü kolayca oluşturun ve yükleyin! Öğeler ekleyin, fiyatları belirleyin ve teknik bilgi olmadan ayrıntıları güncelleyin.",
            },
            {
                title: "Menüyü güncelle",
                description:
                    "Menünüzü istediğiniz zaman gerçek zamanlı olarak güncelleyin! Fiyatları değiştirin, yeni yemekler ekleyin veya kullanılamayan öğeleri anında arşivleyin.",
            },
            {
                title: "Oluştur ve paylaş",
                description:
                    "Menünüz için anında benzersiz bir QR kodu oluşturun! Masalarda, posterlerde veya çevrimiçi olarak paylaşın, müşteriler en son menünüze kolayca erişebilsin.",
            },
        ],
    },

    FEATURES: {
        heading: "Harika özelliklerimizi keşfedin",
        lists: [
            {
                title: "Menüyü yönet",
                description:
                    "Menünüzü istediğiniz zaman yönetin! Teklifinizi güncel tutmak için öğeleri kolayca ekleyin, düzenleyin veya kaldırın.",
            },
            {
                title: "İçgörüler ve raporlar",
                description:
                    "Gerçek zamanlı raporlarla değerli içgörüler elde edin! Menü görüntülemeleri, QR kod taramaları ve müşteri etkileşimlerini izleyin.",
            },
            {
                title: "QR kodları paylaş",
                description:
                    "Menünüzü benzersiz bir QR koduyla paylaşın! Masalarda, posterlerde veya çevrimiçi olarak gösterin, müşteriler hemen tarayabilsin.",
            },
            {
                title: "Müşteri incelemeleri",
                description:
                    "Gerçek müşteri geri bildirimlerini ve puanlarını gösterin! Güveni artırın, menünüzü geliştirin ve yemek deneyimini iyileştirin.",
            },
            {
                title: "Teklifler ve indirimler",
                description:
                    "Özel teklifler ve indirimlerle satışları artırın! Sınırlı süreli promosyonları ve özel indirimleri öne çıkarın.",
            },
        ],
    },

    ABOUT: {
        heading: "My QR Menu hakkında",
        headingPara: "Gerçek zamanlı güncellemelerle restoran menünüzün yönetimini kolaylaştırın.",
        highlightHeading: "İhtiyacınız olan her şeye hızlı ve kolay erişim",
        highlightPara: "Tüm menü özellikleriniz — sadece bir dokunuş uzakta.",
        cards: {
            left: {
                heading: ["Malzemeleri kolayca ekleyin", "QR menünüze"],
                alt: "Malzeme ekle",
            },
            right: {
                heading: ["Menü panonuza", "kolayca erişin"],
                alt: "Menü panosu",
            },
        },
    },

    FAQ: {
        heading: "Sorularınız mı var? Bizim cevaplarımız var.",
        subheading: "Ürün hakkında bilmeniz gereken her şey.",
        items: [
            {
                question: "My QRMenu nedir?",
                answer:
                    "My QRMenu, restoranların QR kod kullanarak menülerini anında oluşturmasına, güncellemesine ve paylaşmasına olanak tanıyan dijital bir menü platformudur.",
            },
            {
                question: "Oluşturduktan sonra menümü güncelleyebilir miyim?",
                answer:
                    "Evet, menünüzü istediğiniz zaman güncelleyebilirsiniz ve müşteriler QR kodunuzu taradığında hemen yansır.",
            },
            {
                question: "My QRMenu nasıl çalışır?",
                answer:
                    "Bir menü oluşturursunuz, bir QR kodu üretirsiniz ve müşteriler bunu tarayarak menünüzün en güncel halini görür.",
            },
            {
                question: "QR kodumu nasıl paylaşırım?",
                answer:
                    "QR kodunu dijital olarak paylaşabilir veya restoranınızda göstermek üzere yazdırabilirsiniz.",
            },
            {
                question: "My QRMenu mobil uyumlu mu?",
                answer:
                    "Evet, My QRMenu akıllı telefonlar ve tabletler dahil tüm cihazlar için optimize edilmiştir.",
            },
            {
                question: "Müşteri yorumları toplayabilir miyim?",
                answer:
                    "Evet, müşteri yorumlarını etkinleştirebilir ve geri bildirimi teklifinizi iyileştirmek için kullanabilirsiniz.",
            },
        ],
    },

    CONTACT: {
        heading: "Bize ulaşın",
        subheading: "Dost canlısı ekibimiz sizi duymak için hazır.",
        firstName: "Ad",
        lastName: "Soyad",
        email: "E-posta",
        message: "Mesaj",
        firstNamePlaceholder: "Ad",
        lastNamePlaceholder: "Soyad",
        emailPlaceholder: "sen@firma.com",
        messagePlaceholder: "Mesajınızı yazın...",
        privacyConsent: "Bizimle aynı fikirde olduğunuzu kabul edersiniz",
        privacyPolicy: "gizlilik politikamız",
        submitButton: "Mesajı Gönder",
        toast: {
            requiredConsent: "Gizlilik politikasını kabul etmelisiniz.",
            submitting: "Mesaj gönderiliyor...",
            success: "Mesaj başarıyla gönderildi!",
            fail: "Mesaj gönderilemedi. Lütfen tekrar deneyin.",
            error: "Bir hata oluştu. Lütfen bağlantınızı kontrol edin.",
        },
    },

    HELP_PAGE: {
        title: "Yardım Merkezi",
        description: "Herhangi bir sorunuz varsa veya desteğe ihtiyacınız varsa lütfen şu adresten bizimle iletişime geçin: ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "Veya aşağıdaki SSS'lerimize göz atın, aradığınızı bulabilirsiniz.",
    },

    FOOTER: {
        footerHeading: "Sorunsuz dijital menüler, basitleştirildi!",
        footerButton: "Bekleme listesine katıl",
        footerConnect: "Bizimle bağlanın",
        footerTerms: "Şartlar ve anlaşmalar",
        footerHelp: "Yardım Merkezi",
        footerPrivacy: "Gizlilik politikası",
        footerCopyright: `©${currentYear} Tüm hakları saklıdır.`,
    },

    PRIVACY_POLICY: {
        title: "Gizlilik Politikası",
        lastUpdated: "Son güncelleme: 22 Mayıs 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                Bu Gizlilik Politikası, Hizmeti kullandığınızda bilgilerinizin toplanması, kullanılması ve ifşa edilmesine ilişkin politikalarımızı ve prosedürlerimizi açıklar.
                </p>
                <p class="mb-6 leading-relaxed">
                Kişisel verilerinizi Hizmeti sağlamak ve iyileştirmek için kullanıyoruz. Hizmeti kullanarak, bilgilerin bu Gizlilik Politikasına uygun olarak toplanmasını ve kullanılmasını kabul etmiş olursunuz.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Yorumlama ve Tanımlar</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">Yorumlama</h3>
                <p class="mb-6 leading-relaxed">
                    İlk harfi büyük olan kelimeler, aşağıdaki koşullar altında tanımlanan anlamlara sahiptir.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">Tanımlar</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>Hesap</strong> Hizmetimize erişmeniz için oluşturulan benzersiz bir hesap anlamına gelir.</li>
                    <li><strong>Şirket</strong> (bu Sözleşmede "Şirket", "Biz", "Bize" veya "Bizim" olarak anılır) <strong>My QR Menu,</strong> Londra, Birleşik Krallık anlamına gelir.</li>
                    <li><strong>Kişisel Veriler</strong> kimliği belirli veya belirlenebilir bir kişiyle ilgili her türlü bilgidir.</li>
                    <li><strong>Siz</strong> Hizmete erişen veya Hizmeti kullanan kişi anlamına gelir.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">Bize Ulaşın</h2>
                <p>
                Bu Gizlilik Politikası hakkında herhangi bir sorunuz varsa, bizimle iletişime geçebilirsiniz:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>E-posta yoluyla: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "Şartlar ve Koşullar",
        lastUpdated: "Son güncelleme: 22 Mayıs 2025",
        content: `
            <p class="leading-relaxed mb-6">
            Uygulamamızı veya Web Sitemizi kullanmadan önce lütfen bu Şartlar ve Koşulları dikkatlice okuyun.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. Yorumlama ve Tanımlar</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Yorumlama</h3>
            <p class="leading-relaxed mb-4">
            İlk harfi büyük olan kelimeler, aşağıdaki koşullar altında tanımlanan anlamlara sahiptir.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Tanımlar</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>Uygulama</strong> My QR Menu tarafından sağlanan yazılım anlamına gelir.</li>
            <li><strong>Şirket</strong> merkezi Londra, İngiltere'de bulunan My QR Menu'yü ifade eder.</li>
            <li><strong>Hizmet</strong> Uygulamayı ve Web Sitemizi ifade eder.</li>
            <li><strong>Siz</strong> Hizmete erişen kişi veya işletme anlamına gelir.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. Onay</h2>
            <p class="leading-relaxed mb-6">
            Hizmete erişerek veya Hizmeti kullanarak bu Şartlara bağlı kalmayı kabul etmiş olursunuz. Herhangi bir bölüme katılmıyorsanız, Hizmete erişemezsiniz.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. Diğer Web Sitelere Bağlantılar</h2>
            <p class="leading-relaxed mb-6">
            Hizmetimiz üçüncü taraf web sitelerine bağlantılar içerebilir. Bunların içeriği veya uygulamaları üzerinde hiçbir kontrolümüz veya sorumluluğumuz yoktur.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. Fesih</h2>
            <p class="leading-relaxed mb-6">
            Herhangi bir nedenle, önceden bildirimde bulunmaksızın Hizmete erişiminizi derhal feshetme veya askıya alma hakkımızı saklı tutarız.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. Sorumluluğun Sınırlandırılması</h2>
            <p class="leading-relaxed mb-6">
            Yasaların izin verdiği azami ölçüde, Şirket Hizmeti kullanımınızdan kaynaklanan hiçbir zarardan sorumlu tutulamaz.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. "OLDUĞU GİBİ" ve "MEVCUT OLDUĞU ŞEKİLDE" Feragatnamesi</h2>
            <p class="leading-relaxed mb-6">
            Hizmet size "OLDUĞU GİBİ" ve "MEVCUT OLDUĞU ŞEKİLDE" esasına göre sunulmaktadır. Kesintisiz veya hatasız olacağını garanti etmiyoruz.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. Uygulanacak Hukuk</h2>
            <p class="leading-relaxed mb-6">
            Bu Şartlar Birleşik Krallık yasalarına tabi olacaktır.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. Uyuşmazlık Çözümü</h2>
            <p class="leading-relaxed mb-6">
            Bizimle bir anlaşmazlığınız varsa, yasal yollara başvurmadan önce bunu gayri resmi olarak çözmeye çalışmayı kabul edersiniz.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. Avrupa Birliği (AB) Kullanıcıları İçin</h2>
            <p class="leading-relaxed mb-6">
            AB'de bir tüketiciyseniz, ikamet ettiğiniz ülkenin yasalarının emredici hükümlerinin korumasından yararlanma hakkına sahipsiniz.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. Amerika Birleşik Devletleri Yasal Uyumu</h2>
            <p class="leading-relaxed mb-6">
            ABD hükümetinin yaptırımlarına tabi bir ülkede bulunmadığınızı beyan ve taahhüt edersiniz.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. Bölünebilirlik ve Feragat</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Bölünebilirlik</h3>
            <p class="leading-relaxed mb-4">
            Bu Şartların herhangi bir hükmünün uygulanamaz olduğu tespit edilirse, geri kalan hükümler yürürlükte kalmaya devam edecektir.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Feragat</h3>
            <p class="leading-relaxed mb-6">
            Bir hükmün uygulanmaması, söz konusu haktan feragat edildiği anlamına gelmez.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. Çeviri Yorumu</h2>
            <p class="leading-relaxed mb-6">
            Bu Şartlar çevrilmiş olabilir. Bir anlaşmazlık durumunda İngilizce sürüm geçerli olacaktır.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. Bu Şartlardaki Değişiklikler</h2>
            <p class="leading-relaxed mb-6">
            Bu Şartları istediğimiz zaman güncelleyebiliriz. Web Sitemizde bir bildirim yayınlayarak sizi bilgilendireceğiz.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. Bize Ulaşın</h2>
            <p class="leading-relaxed mb-2">Bu Şartlar hakkında sorularınız varsa, bizimle iletişime geçebilirsiniz:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>E-posta yoluyla: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
